import { Link } from 'react-router-dom';
import { CATEGORY } from '@/constants/testIds';

export default function CategoryCard({ category }) {
  const slug = category.slug || category.id;
  return (
    <Link
      to={`/shop?category=${slug}`}
      data-testid={CATEGORY.card(slug)}
      className="group flex flex-col items-center gap-3 p-3 rounded-2xl transition-all"
    >
      <div className="aspect-square w-full max-w-[120px] rounded-full bg-gradient-to-br from-brand-50 via-white to-vibrant-50 overflow-hidden ring-1 ring-stone-100 group-hover:ring-2 group-hover:ring-brand-300 shadow-card group-hover:shadow-card-hover group-hover:-translate-y-1 transition-all duration-300">
        <img
          src={category.image_url || '/placeholder.png'}
          alt={category.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
      </div>
      <span className="text-xs sm:text-sm font-semibold text-stone-800 text-center line-clamp-2 group-hover:text-brand-700 transition-colors">{category.name}</span>
    </Link>
  );
}
